import { Button, DataHeader, DataSource, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBrokerageWorkflowProfile extends Layout {
    buttonOpenClassic: Button;
    dataheaderBrokerageWorkflowProfile: DataHeader;
    panelGeneral: Panel;
    sourceBrokerageWorkflowDetail: DataSource;
    sourceBrokerageWorkflowProfile: DataSource;
    switchActive: Switch;
    tabDetails: Tab;
    tabGeneral: Tab;
    tableBrokerageWorkflowDetails: Table;
    tabsetMain: Tabset;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
